import { IconChevronLeft } from 'central-icons/IconChevronLeft';
import { IconChevronRight } from 'central-icons/IconChevronRight';

import styles from './scroll-button.module.css';

export const ScrollButton = ({
  direction,
  visible,
  onClick,
}: {
  direction: 'left' | 'right';
  visible: boolean;
  onClick: () => void;
}) => {
  return (
    <div
      className={styles.scrollButton}
      data-direction={direction}
      data-visible={visible || undefined}
      onClick={onClick}
      aria-hidden={!visible}
      data-testid={`primary-filter-scroll-${direction}`}
    >
      {direction === 'left' ? (
        <IconChevronLeft size={12} className={styles.chevron} />
      ) : (
        <IconChevronRight size={12} className={styles.chevron} />
      )}
    </div>
  );
};
